import { render, staticRenderFns } from "./OfferFormationDialog.vue?vue&type=template&id=741cfcba"
import script from "./OfferFormationDialog.vue?vue&type=script&lang=js"
export * from "./OfferFormationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports